import { isNative } from '../utils/responsivity';
import { Colors } from './Colors';

export const purple1Shadow = {
  shadowColor: Colors.purple1,
  shadowOffset: { width: 0, height: 0 },
  shadowOpacity: 0.5,
  shadowRadius: isNative ? 5 : 10,
  elevation: 10,
};

export const menuContentStyle = {
  marginTop: 5,
  backgroundColor: Colors.purple0,
  borderRadius: 8,
  ...purple1Shadow,
};

export const calendarTheme = {
  calendarBackground: Colors.purple0,
  todayTextColor: Colors.purple1,
  textDisabledColor: Colors.opacity20,
  textSectionTitleColor: Colors.text,
  selectedDayTextColor: Colors.text,
  dayTextColor: Colors.text,
  arrowColor: Colors.purple1,
  selectedDayBackgroundColor: Colors.purple1,
  disabledArrowColor: Colors.opacity20,
  monthTextColor: Colors.text,
  textDayFontFamily: 'Poppins',
  textMonthFontFamily: 'Poppins',
  textDayHeaderFontFamily: 'Poppins',
  todayButtonTextColor: Colors.purple0,
  todayButtonFontFamily: 'Poppins',
  todayButton: {
    backgroundColor: Colors.purple1,
    borderColor: Colors.purple1,
    borderWidth: 1,
    ...purple1Shadow,
  },
  timeLabel: {
    fontFamily: 'Poppins',
    fontSize: 12,
    paddingLeft: 4,
    paddingRight: 4,
  },
  verticalLine: {
    width: 0,
  },
  line: {
    backgroundColor: Colors.opacity20,
  },
  dotStyle: {
    marginTop: 4,
  },
  event: {
    borderWidth: 0,
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
  },
};
